import { render, staticRenderFns } from "./PartnerSubscriptionTerms.vue?vue&type=template&id=42ae4c02&scoped=true&"
import script from "./PartnerSubscriptionTerms.vue?vue&type=script&lang=js&"
export * from "./PartnerSubscriptionTerms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42ae4c02",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/paywall/partner/sections/PartnerSubscriptionTerms.vue
// module id = 1567
// module chunks = 0